import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

export const InlineCta = ({ source, text, variant = "primary", light = false }) => (
  <Reveal className="mt-14 flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:gap-6">
    <CtaButton testId={`inline-cta-${source}`} source={source} variant={variant} />
    <p className={`text-sm sm:text-base ${light ? "text-cream/85" : "text-navy/75"}`}>{text}</p>
  </Reveal>
);
